<template>
  <el-card class="cms-banner card card__main">
    <div class="service-header">
      <h2 class="service-title">咨询服务购买</h2>
      <p class="service-subtitle">专业的人类图咨询服务，助您更好地了解自己</p>
    </div>

    <!-- 服务列表 -->
    <div class="service-list">
      <el-row :gutter="20">
        <el-col :span="8" v-for="service in serviceList" :key="service.id">
          <el-card class="service-card" shadow="hover">
            <div class="service-image">
              <el-image 
                :src="service.image" 
                fit="cover"
                class="service-img"
                :preview-src-list="[service.image]">
              </el-image>
            </div>
            <div class="service-content">
              <h3 class="service-name">{{ service.name }}</h3>
              <p class="service-description">{{ service.description }}</p>
              <div class="service-features">
                <el-tag 
                  v-for="feature in service.features" 
                  :key="feature"
                  size="small" 
                  type="info" 
                  class="feature-tag">
                  {{ feature }}
                </el-tag>
              </div>
              <div class="service-price">
                <span class="price-symbol">¥</span>
                <span class="price-amount">{{ service.price }}</span>
                <span class="price-unit">/次</span>
              </div>
              <div class="service-actions">
                <el-button 
                  type="primary" 
                  size="medium" 
                  @click="showServiceDetail(service)"
                  class="detail-btn">
                  查看详情
                </el-button>
                <el-button 
                  type="success" 
                  size="medium" 
                  @click="showBuyDialog(service)"
                  class="buy-btn">
                  立即购买
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 服务详情弹窗 -->
    <el-dialog
      title="服务详情"
      :visible.sync="detailDialog.visible"
      width="600px"
      center
      class="service-detail-dialog">
      <div v-if="detailDialog.service" class="service-detail">
        <div class="detail-header">
          <el-image 
            :src="detailDialog.service.image" 
            fit="cover"
            class="detail-image">
          </el-image>
          <div class="detail-info">
            <h3>{{ detailDialog.service.name }}</h3>
            <div class="detail-price">
              <span class="price-symbol">¥</span>
              <span class="price-amount">{{ detailDialog.service.price }}</span>
              <span class="price-unit">/次</span>
            </div>
          </div>
        </div>
        <div class="detail-description">
          <h4>服务介绍</h4>
          <p>{{ detailDialog.service.description }}</p>
        </div>
        <div class="detail-features">
          <h4>服务特色</h4>
          <ul>
            <li v-for="feature in detailDialog.service.features" :key="feature">
              {{ feature }}
            </li>
          </ul>
        </div>
        <div class="detail-process">
          <h4>服务流程</h4>
          <div class="process-steps">
            <div class="step" v-for="(step, index) in detailDialog.service.process" :key="index">
              <div class="step-number">{{ index + 1 }}</div>
              <div class="step-content">
                <h5>{{ step.title }}</h5>
                <p>{{ step.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
        <el-button 
          type="primary" 
          @click="showBuyDialog(detailDialog.service)">
          立即购买
        </el-button>
      </span>
    </el-dialog>

    <!-- 购买弹窗 -->
    <el-dialog
      title="扫码购买"
      :visible.sync="buyDialog.visible"
      width="400px"
      center
      class="buy-dialog">
      <div v-if="buyDialog.service" class="buy-content">
        <div class="buy-service-info">
          <h4>{{ buyDialog.service.name }}</h4>
          <div class="buy-price">
            <span class="price-symbol">¥</span>
            <span class="price-amount">{{ buyDialog.service.price }}</span>
            <span class="price-unit">/次</span>
          </div>
        </div>
        
        <div class="qr-code-section">
          <div class="qr-code-container">
            <el-image 
              :src="require('@/assets/services/qr-code-placeholder.svg')"
              class="qr-code-image"
              fit="contain">
            </el-image>
          </div>
          <p class="qr-tip">请使用微信扫描二维码完成支付</p>
        </div>

        <div class="payment-info">
          <el-form :model="paymentForm" label-width="80px">
            <el-form-item label="姓名">
              <el-input v-model="paymentForm.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="paymentForm.phone" placeholder="请输入您的手机号"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input 
                v-model="paymentForm.remark" 
                type="textarea" 
                placeholder="请输入备注信息（可选）">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="buyDialog.visible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="confirmPayment"
          :loading="paymentLoading">
          确认支付
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
// import dayjs from "dayjs";
export default {
  name: "MockBuy",
  components: {},
  data() {
    return {
      user: null,
      serviceList: [
        {
          id: 1,
          name: "人类图基础解读",
          description: "专业的人类图基础解读服务，帮助您了解自己的天赋特质和人生使命。",
          price: 299,
          image: require("@/assets/services/basic-reading.svg"),
          features: ["30分钟解读", "基础报告", "在线咨询"],
          process: [
            {
              title: "提交信息",
              description: "提供您的出生时间和地点信息"
            },
            {
              title: "生成图表",
              description: "系统自动生成您的人类图"
            },
            {
              title: "专家解读",
              description: "专业咨询师为您详细解读"
            },
            {
              title: "获得报告",
              description: "获得详细的解读报告和建议"
            }
          ]
        },
        {
          id: 2,
          name: "人类图深度分析",
          description: "深入分析您的人类图，包括能量中心、通道、闸门等详细解读。",
          price: 599,
          image: require("@/assets/services/deep-analysis.svg"),
          features: ["60分钟解读", "详细报告", "一对一咨询", "后续跟进"],
          process: [
            {
              title: "信息收集",
              description: "收集详细的个人信息和需求"
            },
            {
              title: "图表分析",
              description: "深度分析人类图的各个层面"
            },
            {
              title: "专家咨询",
              description: "一对一深度咨询解读"
            },
            {
              title: "报告交付",
              description: "获得完整的分析报告和建议"
            }
          ]
        },
        {
          id: 3,
          name: "人类图职业指导",
          description: "基于人类图的职业发展指导，帮助您找到最适合的职业方向。",
          price: 899,
          image: require("@/assets/services/career-guidance.svg"),
          features: ["90分钟解读", "职业报告", "发展建议", "3个月跟进"],
          process: [
            {
              title: "职业评估",
              description: "评估当前职业状况和发展需求"
            },
            {
              title: "图表分析",
              description: "分析人类图中的职业相关特质"
            },
            {
              title: "专家指导",
              description: "专业职业规划师一对一指导"
            },
            {
              title: "规划方案",
              description: "制定个性化的职业发展方案"
            }
          ]
        }
      ],
      detailDialog: {
        visible: false,
        service: null
      },
      buyDialog: {
        visible: false,
        service: null
      },
      paymentForm: {
        name: "",
        phone: "",
        remark: ""
      },
      paymentLoading: false
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("RLTuser"));
    // 如果有用户信息，预填充表单
    if (this.user) {
      this.paymentForm.name = this.user.name || "";
      this.paymentForm.phone = this.user.phone || "";
    }
  },
  methods: {
    showServiceDetail(service) {
      this.detailDialog.service = service;
      this.detailDialog.visible = true;
    },
    showBuyDialog(service) {
      this.buyDialog.service = service;
      this.buyDialog.visible = true;
      this.detailDialog.visible = false;
      // 这里可以生成支付二维码
      this.generateQRCode();
    },
    generateQRCode() {
      // 这里可以集成真实的二维码生成库，如 qrcode.js
      // 暂时使用占位符
      console.log("生成支付二维码");
    },
    confirmPayment() {
      if (!this.paymentForm.name || !this.paymentForm.phone) {
        this.$message.warning("请填写姓名和手机号");
        return;
      }
      
      this.paymentLoading = true;
      
      // 模拟支付过程
      setTimeout(() => {
        this.paymentLoading = false;
        this.buyDialog.visible = false;
        this.$message.success("支付成功！我们会尽快与您联系安排咨询服务。");
        
        // 重置表单
        this.paymentForm = {
          name: this.user ? this.user.name || "" : "",
          phone: this.user ? this.user.phone || "" : "",
          remark: ""
        };
      }, 2000);
    }
  },
};
</script>

<style scoped>
.service-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px 0;
}

.service-title {
  font-size: 28px;
  color: #303133;
  margin-bottom: 10px;
}

.service-subtitle {
  font-size: 16px;
  color: #909399;
}

.service-list {
  margin-bottom: 30px;
}

.service-card {
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.service-image {
  height: 200px;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}

.service-img {
  width: 100%;
  height: 100%;
}

.service-content {
  padding: 20px;
}

.service-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.service-description {
  color: #606266;
  line-height: 1.6;
  margin-bottom: 15px;
  height: 48px;
  overflow: hidden;
}

.service-features {
  margin-bottom: 15px;
}

.feature-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.service-price {
  margin-bottom: 20px;
  text-align: center;
}

.price-symbol {
  font-size: 16px;
  color: #f56c6c;
}

.price-amount {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
  margin: 0 5px;
}

.price-unit {
  font-size: 14px;
  color: #909399;
}

.service-actions {
  display: flex;
  gap: 10px;
}

.detail-btn, .buy-btn {
  flex: 1;
}

/* 详情弹窗样式 */
.service-detail-dialog .el-dialog__body {
  padding: 20px;
}

.detail-header {
  display: flex;
  margin-bottom: 20px;
}

.detail-image {
  width: 120px;
  height: 80px;
  border-radius: 8px;
  margin-right: 20px;
}

.detail-info h3 {
  margin: 0 0 10px 0;
  color: #303133;
}

.detail-price {
  margin-bottom: 10px;
}

.detail-description,
.detail-features,
.detail-process {
  margin-bottom: 20px;
}

.detail-description h4,
.detail-features h4,
.detail-process h4 {
  color: #303133;
  margin-bottom: 10px;
}

.detail-features ul {
  padding-left: 20px;
}

.detail-features li {
  margin-bottom: 5px;
  color: #606266;
}

.process-steps {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.step {
  display: flex;
  align-items: flex-start;
}

.step-number {
  width: 30px;
  height: 30px;
  background: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 15px;
  flex-shrink: 0;
}

.step-content h5 {
  margin: 0 0 5px 0;
  color: #303133;
}

.step-content p {
  margin: 0;
  color: #606266;
  line-height: 1.5;
}

/* 购买弹窗样式 */
.buy-dialog .el-dialog__body {
  padding: 20px;
}

.buy-service-info {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.buy-service-info h4 {
  margin: 0 0 10px 0;
  color: #303133;
}

.qr-code-section {
  text-align: center;
  margin-bottom: 20px;
}

.qr-code-container {
  margin-bottom: 15px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin: 0 auto;
  display: block;
}

.qr-tip {
  color: #909399;
  font-size: 14px;
  margin: 0;
}

.payment-info {
  border-top: 1px solid #ebeef5;
  padding-top: 15px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-col {
    width: 100% !important;
  }
  
  .service-actions {
    flex-direction: column;
  }
  
  .detail-header {
    flex-direction: column;
    text-align: center;
  }
  
  .detail-image {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
